exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".color[data-v-68ae157c]{width:30px;height:30px;float:left;margin-right:5px;margin-bottom:5px;border-radius:4px;box-sizing:border-box}.color.active[data-v-68ae157c]{border:3px solid #000;border:3px solid hsla(0,0%,100%,.6)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-68ae157c","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/Color.vue
// module id = 50
// module chunks = 0